import { Grid, Grid2, Typography } from "@mui/material";
import { Commons } from "../../helper/CommonService";
import { QRCodeSVG } from 'qrcode.react';
import { useEffect, useState } from "react";
import { Downloads } from "../../helper/DownloadService";
import { API_HOST, BE_HOST, CONFIG_PENDAFTARAN, FOTO_HOST } from "../../helper/Constant";
import { MainIcon } from "../../helper/MainIcon";

function FotoSantri({ dataSantri, foto }) {
    return (
        <>
            <Grid container>
                <Grid sx={{
                    padding: "5px", textAlign: "center", display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }} xs={6} sm={6} md={6} lg={6} xl={6}>
                    <div style={{ padding: "10px", border: "1px solid #000000" }}>
                        <table>
                            <tr>
                                <td align="right">
                                    <img style={{ height: "50px" }} src={MainIcon.MainLogo()}></img>
                                </td>
                                <td align="left">
                                    <b>
                                        PSB {dataSantri.tahun_ajaran.tahun_ajaran}
                                        <br></br>
                                        {dataSantri.tujuan.jenjang_tujuan}
                                    </b>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={"2"} align="center">
                                    {/* ✅ ID card photo: 3:4 ratio, height matches QR code (256px) */}
                                    <img
                                        style={{
                                            width: "192px",           // ✅ 3:4 ratio (192:256 = 3:4)
                                            height: "256px",          // ✅ Same as QR code
                                            objectFit: "cover",       // ✅ Crop to fill
                                            objectPosition: "center top", // ✅ Focus on face
                                            border: "1px solid #ddd",
                                            display: "block",
                                            margin: "0 auto"
                                        }}
                                        src={foto || MainIcon.DefaultFoto()}
                                    />
                                    <br></br>
                                    <b>
                                        {dataSantri.no_daftar}
                                        <br></br>
                                        {dataSantri.nama}
                                    </b>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Grid>
                <Grid sx={{ padding: "5px" }} xs={6} sm={6} md={6} lg={6} xl={6}>
                    <div style={{ padding: "10px", border: "1px solid #000000" }}>
                        <center>
                            <img style={{ height: "50px" }} src={MainIcon.MainLogo()}></img>
                            <br></br>
                            <QRCodeSVG
                                value={dataSantri.no_daftar}
                                size={256}
                                bgColor="#ffffff"
                                fgColor="#000000"
                                level="Q"
                            />
                            <br></br>
                            <b>
                                {dataSantri.no_daftar}
                                <br></br>
                                {dataSantri.nama}
                            </b>
                        </center>
                    </div>
                </Grid>
            </Grid>
        </>
    )
}

export default FotoSantri;